import {
  NavItem,
  NavItemType
} from "@/pages/settings/components/settingsNav/NavItem";
import Text from "@/components/ui/text";

export interface NavSectionProps {
  title: string;
  items: NavItemType[];
  currentPageName?: string;
  onPageClick: (targetName: string) => void;
}

export interface NavSectionType {
  title: string;
  items: NavItemType[];
}

export function NavSection({
  title,
  items,
  currentPageName,
  onPageClick
}: NavSectionProps) {
  return (
    <div>
      <Text variant="smLabelTertiary" className="px-[10px] py-1 font-normal">
        {title}
      </Text>
      <div>
        {items.map((item) => (
          <NavItem
            key={item.target}
            item={item}
            onPageClick={onPageClick}
            currentPageName={currentPageName}
          />
        ))}
      </div>
    </div>
  );
}
